import classNames from "classnames";
import { Flag } from "../../../../../components";
import { DateHelper, StringHelper } from "../../../../../helper";
import { useBCSteps } from "./use-BC-steps";

export const useBCColumns = () => {
  const { approve } = useBCSteps();
  const columns = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
    },
    {
      title: "Người tạo",
      dataIndex: "eCreatedBy",
      key: "eCreatedBy",
      render: (text: string) =>
        StringHelper.verticalBarSplit<string[]>(text)[1],
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: () => <Flag flag="success">Cấp mới</Flag>,
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render: (text: string, record: any = {}) => {
        const { status } = approve(record?.eApprovalProcess);
        return (
          <div className={classNames("flag", status.flag)}>{status.label}</div>
        );
      },
    },
  ];
  return { columns };
};
